import AddCustomSupplyArea from "@/pages/comp/supply/supply/common/add_custom_supply";

function AddCustomSupplyPopup(props:any){
   let myProps={
    stu_seq_arr: [],
    supply_row_data: {},
    refresh_data:(inData:any)=>{},
    closePopup:()=>{},
    ...props
  };
  
  return (
  <div>
    <AddCustomSupplyArea
      stu_seq_arr={myProps.stu_seq_arr}
      supply_row_data={myProps.supply_row_data}
      refresh_data={myProps.refresh_data}
      is_show_close={true}
      close={myProps.closePopup}
    ></AddCustomSupplyArea>
  </div>
  );
};
export default AddCustomSupplyPopup;